// WHAT A PROPOSAL ROW SAYS WHILE ITS IMPORT IS BEING APPLIED.
//
// Owner, 2026-10-02: "just mark it if its being processed, and show a ui,
// saying next to it its being processed, until you get a notification from
// the job that it is done, also hide the notif accordingly, unless the job
// fails, then show the notif again for that job and add a 1 sentence
// report bellow accept button saying this has failed please reach out to
// the person exported the model."
//
// And on who the hiding is for: "for who ever started the job, other
// people when they check it will tell them, this is being processed."
//
// WHY THIS EXISTS AT ALL. A group apply runs six to eight minutes on the
// worker, and its proposals stay OPEN the whole time - so the badge kept
// counting them and the owner read it as his apply having failed. He went
// round the import-and-apply loop six times today partly on the strength
// of that number. The work was never wrong; the screen was.
//
// THE RULES, in one place because three surfaces read them:
//   processing      somebody's apply is running on this group. EVERYONE
//                   sees the label. Only the starter has it taken off
//                   their count, and the server does that - the client is
//                   never handed a number it has to adjust.
//   failed          the last run of this group failed, or was killed. The
//                   notification comes back for EVERYBODY, including the
//                   starter, because that is the signal.
//   neither         the row behaves exactly as it did before.
// A row is never both: the server resolves that, and a UI showing "being
// processed" and "has failed" at once would be two contradictory
// statements about one thing.

export const APPLY_FAILED_SENTENCE =
  "This has failed - please reach out to the person who exported the model.";

// The label beside a row, or "" for none. It names the PART so a six-minute
// job reads as progress rather than as a hang - a bare "processing" on a
// job that died looks identical to one that is working.
export function processingLabel(m) {
  if (!m || !m.processing) return "";
  const part = m.processingPart ? ` · ${m.processingPart}` : "";
  // WHOSE job it is, when it is not yours. Somebody looking at a project
  // and seeing a count they cannot clear needs to know who to ask.
  const who = m.processingMine ? "" : (m.processingBy ? ` · started by ${m.processingBy}` : "");
  return `Being processed${part}${who}`;
}

// Is this row's apply still in flight? The buttons go quiet while it is -
// pressing Apply again is what put eight concurrent applies in one heap.
export function isProcessing(m) {
  return !!(m && m.processing);
}

// The sentence under the Accept button, and the reason beside it.
//
// THE INSTRUCTION IS HIS WORDS AND THE REASON IS KEPT SEPARATE. He asked
// for "please reach out to the person exported the model" - that is what a
// person can act on. The run's own message (the 16 MB ceiling, say) is
// what whoever debugs it needs, and burying one in the other serves
// neither.
export function failureNote(m) {
  if (!m || !m.applyFailed) return null;
  return {
    sentence: m.applyFailedNote || APPLY_FAILED_SENTENCE,
    reason: m.applyFailedReason || "",
    at: m.applyFailedAt || null,
  };
}

// Should the group-apply button be offered at all?
//
// Not while the group is being applied - that is the second press that
// took production down - and YES after a failure, because the owner's
// whole point is that a failed job comes back so it can be dealt with.
export function canApplyGroup(m) {
  if (!m || !m.groupId) return false;
  if (isProcessing(m)) return false;
  return (m.groupOpenParts || 0) > 1;
}
